import React from 'react'
import { Box, makeStyles } from '@material-ui/core'
import {
  CommentLocationType,
  ProjectFragment,
  ProjectVersionFragment,
} from '../../generated/graphql'
import { ProjectVersionPicker } from '../form/ProjectVersionPicker'
import { ProjectVersionsButton } from './ProjectVersionsButton'
import { CommentsButton } from '../comments/CommentsButton'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
}))

type ProjectVersionsParams = {
  project: ProjectFragment
  activeVersion: ProjectVersionFragment
  onVersionSelected: (version: ProjectVersionFragment) => void
}

export function ProjectVersions({
  project,
  activeVersion,
  onVersionSelected,
}: ProjectVersionsParams): React.ReactElement {
  const classes = useStyles()

  const handleVersionChange = (versionId: string) => {
    const version = project.versions.find((v) => v.id === versionId)
    if (version) {
      onVersionSelected(version)
    }
  }

  return (
    <Box className={classes.container}>
      <CommentsButton locationType={CommentLocationType.EnergyCalculation} />

      <ProjectVersionPicker
        versions={project.versions}
        value={activeVersion.id}
        onChange={handleVersionChange}
      />

      <ProjectVersionsButton
        project={project}
        activeVersion={activeVersion}
        onVersionSelected={onVersionSelected}
      />
    </Box>
  )
}
